import { extendTheme, ThemeOverride, withDefaultColorScheme } from '@chakra-ui/react';

import colors from './colors';
import components from './components';
import styles from './styles';
import tokens from './tokens';

const base: ThemeOverride = {
  styles,
  components,
  colors,
  initialColorMode: 'dark',
  useSystemColorMode: false,
  semanticTokens: tokens,
  // ── Reskin "Refined Indigo" scales (design-guidelines.md) ──
  fonts: {
    heading: "'Space Grotesk', ui-sans-serif, system-ui, sans-serif",
    body: "'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, monospace",
  },
  // Type scale = mockup tokens.css (xs12·sm13·base14·md16·lg18·xl22·2xl28·3xl36).
  // Body defaults to `base` (14px); PageHeader title uses `2xl` (28px).
  fontSizes: {
    xs: '12px',
    sm: '13px',
    base: '14px',
    md: '16px',
    lg: '18px',
    xl: '22px',
    '2xl': '28px',
    '3xl': '36px',
  },
  radii: {
    sm: '6px',
    md: '10px',
    lg: '14px',
    xl: '20px',
    full: '9999px',
  },
  sizes: {
    sidebar: '264px',
    sidebarCollapsed: '72px',
    topbar: '64px',
  },
  // App shell collapses the sidebar to a hamburger drawer at tablet (768) and
  // below; the persistent sidebar shows only on desktop. Chakra's default
  // `lg` is 62em (992px), which left tablets 992–1023px on the persistent
  // sidebar. Raise `lg` to 64em (1024px) so `{ base, lg }` props treat
  // tablet + mobile as drawer and desktop ≥1024 as persistent.
  breakpoints: {
    sm: '30em', // 480px
    md: '48em', // 768px
    lg: '64em', // 1024px — desktop threshold
    xl: '80em', // 1280px
    '2xl': '96em', // 1536px
  },
};

const theme = extendTheme(
  base,
  withDefaultColorScheme({
    colorScheme: 'primary',
    components: ['Tab', 'Tabs', 'TabList'],
  }),
  withDefaultColorScheme({
    colorScheme: 'white',
    components: ['Input', 'Textarea'],
  })
);
export default theme;
